var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAthletic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.1,67.4l-47.3,47.3c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l20.3-20.3h41.5c1.3,0,2.6-0.5,3.6-1.5c1-1,1.5-2.3,1.5-3.6 c0-1.3-0.5-2.6-1.5-3.6L60.1,67.4z M60.1,81.9l9.4,9.4H50.7L60.1,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.6,51c-2-2-5.3-2-7.3,0l-9.1,9.1L80.8,27.8c-0.9-0.9-2.2-1.5-3.6-1.5c-1.4,0-2.7,0.6-3.6,1.5L59,42.3c-2,2-2,5.3,0,7.3 c2,2,5.3,2,7.3,0l10.9-10.9l5.8,5.8L63.7,63.7l16.4,16.4l19.3-19.3l10.2,10.2c2,2,5.3,2,7.3,0l12.8-12.8 C131.6,56.3,131.6,53,129.6,51z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 36,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthletic);
export default __webpack_public_path__ + "static/media/athletic.669a926a208f898ac0cd5a75657ec539.svg";
export { ForwardRef as ReactComponent };